import { bl_fi_my_einvoice_from_irb_document_queue_RowClass } from '../../dbschema/bl_fi_my_einvoice_from_irb_document_queue.model';
import { BaseContainerModel } from '../base-container.model';

export class FromIRBDocumentQueueContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_from_irb_document_queue: bl_fi_my_einvoice_from_irb_document_queue_RowClass = new bl_fi_my_einvoice_from_irb_document_queue_RowClass();
}
